/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * The kind of change a Compliance.Forms.Models.Forms.History.FormDefinitionChangeDetail records.
 */
export enum FormDefinitionChangeType {
    ELEMENT_ADDED = 'ElementAdded',
    ELEMENT_CHANGED = 'ElementChanged',
    ELEMENT_REMOVED = 'ElementRemoved',
    META_CHANGED = 'MetaChanged',
    RULE_CHANGED = 'RuleChanged',
}
